/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overviewkpiplanning2Inputs */

const en_overviewkpiplanning2 = /** @type {(inputs: Overviewkpiplanning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planning to visit`)
};

const de_overviewkpiplanning2 = /** @type {(inputs: Overviewkpiplanning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planen zu kommen`)
};

/**
* | output |
* | --- |
* | "Planning to visit" |
*
* @param {Overviewkpiplanning2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewkpiplanning2 = /** @type {((inputs?: Overviewkpiplanning2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewkpiplanning2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewkpiplanning2(inputs)
	return de_overviewkpiplanning2(inputs)
});
export { overviewkpiplanning2 as "overviewKpiPlanning" }